import { Agent } from "../interfaces/agent.interface";

export type AgentAuxStatus = 'available' | 'logged-in' | 'logged-out' | 'aux';

export const getAgentAuxStatus = (agentInfo: Agent): AgentAuxStatus => {
    if (agentInfo != null) {
        if (agentInfo.IsConnected === true) {
            if (agentInfo.IsLoggedIn === true) {
                if (agentInfo.AgentCurrentAuxCode?.toLowerCase() === 'loggedin')
                    return 'logged-in';
                else return 'aux';
            }
            else return 'available';
        }
        else return 'logged-out';
    }
    else return 'logged-out';
}
